<template>
  <div class="u-collapsible">
    <div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
  import { EventType } from '@/shared/enums';

  export default {
    props: {
      expanded: {
        default: false,
        type: Boolean,
      },
    },
    watch: {
      expanded: 'refreshHeight',
    },
    mounted() {
      this.$EventBus.on(EventType.RESIZE, this.refreshHeight);
      this.refreshHeight();
    },
    beforeDestroy() {
      this.$EventBus.off(EventType.RESIZE, this.refreshHeight);
    },
    methods: {
      refreshHeight() {
        this.$nextTick(() => {
          this.$el.style.height = (this.expanded ? this.$el.firstChild.scrollHeight : 0) + 'px';
        });
      },
    },
  };
</script>
